import { render, staticRenderFns } from "./EditCategories.vue?vue&type=template&id=700ba24d&scoped=true"
import script from "./EditCategories.vue?vue&type=script&lang=js"
export * from "./EditCategories.vue?vue&type=script&lang=js"
import style0 from "./EditCategories.vue?vue&type=style&index=0&id=700ba24d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700ba24d",
  null
  
)

export default component.exports